<template>
<div class="deleteProfile popUp wp470 mailSent">
<div class="headerPopUP flex">
  <h4>{{ $t("delete_profile.title") }}</h4>
  <span v-on:click="closePopup()" class="warpit_icon_x closePopUp"></span>
</div>
  <img src="@/assets/images/mailOnWay.svg">
<strong>{{ $t("delete_profile.description") }}</strong>
  <p>{{ $t("delete_profile.description2") }}</p>
</div>
</template>
<script>
export default {
  name:"AccountDeleteVerification",
  data(){
    return {
      closeDeleteMessage:false
    }
  },
  methods:{
    closePopup(){
       this.$emit("closeDeleteMessage", this.closeDeleteMessage);
    }
  }
}
</script>